import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type ContentSource = WithLegacy<{
  url: string | null;
  platform: string | null;
  sourceType: string | null;
  imagePath: string | null;
  state: string | null;
  errorMessage: string | null;
  errorType: string | null;
  title: string | null;
  description: string | null;
  postedAt: string | null;
  language: string | null;
  duration: number | null;
  thumbnailUrl: string | null;
  viewCount: number | null;
  likeCount: number | null;
  commentCount: number | null;
  repostCount: number | null;
  downloadedAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  creator: import('./creator.ts').Creator | null;
  summaries: import('./summary.ts').Summary[];
  recipes: import('./recipe.ts').Recipe[];
  [Type]: 'content-sources';
}>;

export const ContentSourceSchema = withDefaults({
  type: 'content-sources',
  fields: [
    { name: 'url', kind: 'attribute', type: 'string' },
    { name: 'platform', kind: 'attribute', type: 'string' },
    { name: 'sourceType', kind: 'attribute', type: 'string' },
    { name: 'imagePath', kind: 'attribute', type: 'string' },
    { name: 'state', kind: 'attribute', type: 'string' },
    { name: 'errorMessage', kind: 'attribute', type: 'string' },
    { name: 'errorType', kind: 'attribute', type: 'string' },
    { name: 'title', kind: 'attribute', type: 'string' },
    { name: 'description', kind: 'attribute', type: 'string' },
    { name: 'postedAt', kind: 'attribute', type: 'string' },
    { name: 'language', kind: 'attribute', type: 'string' },
    { name: 'duration', kind: 'attribute', type: 'number' },
    { name: 'thumbnailUrl', kind: 'attribute', type: 'string' },
    { name: 'viewCount', kind: 'attribute', type: 'number' },
    { name: 'likeCount', kind: 'attribute', type: 'number' },
    { name: 'commentCount', kind: 'attribute', type: 'number' },
    { name: 'repostCount', kind: 'attribute', type: 'number' },
    { name: 'downloadedAt', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    {
      name: 'mentions',
      kind: 'hasMany',
      type: 'mentions',
      options: { async: true, inverse: null },
    },
    {
      name: 'creator',
      kind: 'belongsTo',
      type: 'creators',
      options: { async: false, inverse: null },
    },
    {
      name: 'podcast',
      kind: 'belongsTo',
      type: 'podcasts',
      options: { async: true, inverse: null },
    },
    {
      name: 'summaries',
      kind: 'hasMany',
      type: 'summaries',
      options: { async: false, inverse: null },
    },
    {
      name: 'recipes',
      kind: 'hasMany',
      type: 'recipes',
      options: { async: true, inverse: null },
    },
  ],
});
